import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/navbar';
import Footer from './components/footer/footer';
import WhatsApp from './components/whatsappButton.js/whatsapp';
import Homepage from './pages/homepage';
import Aboutpage from './pages/aboutpage';
import Productpage from './pages/productpage';
import Gallery from './pages/gallery';
import Contactpage from './pages/contactpage';
import ProductDetailsPage from './pages/productDetailsPage';
import ScrollToTop from './components/scrollToTop';

function App() {

  useEffect(() => {
    AOS.init({ duration: 1000, easing: "ease-out-cubic" });
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/about' element={<Aboutpage />} />
        {/* <Route path='/products' element={<Productpage />} /> */}
        <Route path="/products/:category" element={<Productpage />} />
        <Route path='/gallery' element={<Gallery />} />
        <Route path='/contact' element={<Contactpage />} />
        <Route path='/productDetails/:id' element={<ProductDetailsPage />} />
      </Routes>


      <Footer />

      <WhatsApp phoneNumber="9000331339" />

    </BrowserRouter>
  );
}

export default App;
